import TooltipClose from "~/ui/tooltip-close";
import { RIBBON_TRANS } from "./trans";

export function createMinimalizeTooltip(onClose: () => void) {
	const parent = document.getElementById("all-controls");
	const tooltip = new TooltipClose({
		arrow: "down",
		className: "ribbonTooltip__minimalize ribbonTooltip__common",
		onClose: () => {
			tooltip.container.remove();
			onClose();
		},
	});
	const cont = document.createElement("p");

	cont.classList.add("ribbonTooltip__cont");
	cont.textContent = RIBBON_TRANS.TOOLTIP_MINIMALIZE;
	tooltip.container.append(cont);
	parent.append(tooltip.container);

	return tooltip;
}

export function createHideTooltip(onClose: () => void) {
	const parent = document.getElementById("all-controls");
	const tooltip = new TooltipClose({
		className: "ribbonTooltip__hide ribbonTooltip__common",
		onClose: () => {
			tooltip.container.remove();
			onClose();
		},
	});
	const cont = document.createElement("p");

	cont.classList.add("ribbonTooltip__cont");
	cont.innerHTML = RIBBON_TRANS.TOOLTIP_HIDE.replace("{link}", `<a href='#'>${RIBBON_TRANS.TOOLTIP_HIDE_LINK}</a>`);
	cont.querySelector("a").addEventListener("click", event => {
		event.stopPropagation();
		event.preventDefault();
		tooltip.container.remove();
		Mapy.getComponent("settings").activate();
	});
	tooltip.container.append(cont);
	parent.append(tooltip.container);

	return tooltip;
}
